<template>
  <div class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div>
          <i class="icon-note"></i> Customers Analytics
          {{ analytic_id ? " - Edit" : " - New" }}
        </div>
        <b-button-group>
          <router-link :to="`/analytics`" class="link">
            <b-button class="custom-cancel"
              ><i class="fa fa-times text-danger"></i> Cancel
            </b-button>
          </router-link>
          <b-button
            v-on:click="post('andClose')"
            :disabled="disabled || submitted"
            ><i class="fa fa-save"></i> Save & Close</b-button
          >
          <b-button v-on:click="post()" :disabled="disabled"
            ><i class="fa fa-check text-success "></i> Apply</b-button
          >
        </b-button-group>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col md="10">
            <H3>{{ analytic_name }}</H3>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="10">
            <div>
              <b-tabs>
                <!-- ### Details TAB ### -->
                <b-tab v-on:click="assignCurrentTab('0')" title="Details">
                  <b-card-body>
                    <b-row>
                      <b-col md="6">
                        <!-- Analytics Name -->
                        <b-form-group
                          label="Name"
                          label-for="analyticReportName"
                        >
                          <b-form-input
                            id="analyticReportName"
                            type="text"
                            v-model.lazy.trim="
                              $v.form.analyticReportName.$model
                            "
                            :state="chkState('analyticReportName')"
                            placeholder="Name"
                            autofocus
                          />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2
                            characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>

                      <b-col md="6">
                        <b-form-group
                          label="Data Source"
                          label-for="dataSource_name"
                        >
                          <v-select
                            id="dataSource_name"
                            size="lg"
                            :plain="true"
                            :options="dataSource"
                            v-model.lazy.trim="$v.form.dataSource_name.$model"
                            :state="chkState('dataSource_name')"
                            @input="handleChangeDataSource($event)"
                            placeholder="Choose one or more..."
                          >
                          </v-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="12">
                        <!-- Descriotion -->
                        <b-form-group>
                          <label for="description">Description</label>
                          <vue-editor v-model="description"></vue-editor>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-tab>

                <!-- ### Data TAB ### -->
                <b-tab
                  v-if="isdata"
                  v-on:click="assignCurrentTab('1')"
                  title="Data"
                >
                  <b-row>
                    <b-col md="12">
                      <h3>Columns</h3>
                    </b-col>
                    <b-col md="6">
                      <div class="list-box-wrapper">
                        <div class="subject-info-box-1">
                          <b-form-group>
                            <b-form-select
                              ref="lstBoxColumnLeft"
                              class="form-control"
                              :plain="true"
                              :multiple="true"
                              :options="columnOptionsLeft"
                              v-model="box_column1"
                            >
                            </b-form-select>
                          </b-form-group>
                        </div>

                        <div class="subject-info-arrows text-center">
                          <input
                            type="button"
                            id="btnAllRight"
                            v-on:click="btnColumnAllRight('>>')"
                            value=">>"
                            class="btn btn-default"
                          /><br />
                          <input
                            type="button"
                            id="btnRight"
                            v-on:click="btnColumnRight('>')"
                            value=">"
                            class="btn btn-default"
                          /><br />
                          <input
                            type="button"
                            id="btnLeft"
                            v-on:click="btnColumnLeft('<')"
                            value="<"
                            class="btn btn-default"
                          /><br />
                          <input
                            type="button"
                            id="btnAllLeft"
                            v-on:click="btnColumnAllLeft('<<')"
                            value="<<"
                            class="btn btn-default"
                          />
                        </div>

                        <div class="subject-info-box-2">
                          <b-form-group>
                            <b-form-select
                              ref="lstBoxColumnRight"
                              class="form-control"
                              :plain="true"
                              :multiple="true"
                              v-model="box_column2"
                              :options="columnOptionsRight"
                            >
                            </b-form-select>
                          </b-form-group>
                        </div>

                        <div class="clearfix"></div>
                      </div>
                    </b-col>
                    <b-col md="6"> </b-col>
                  </b-row>

                  <hr class="mnr-md mnl-md" />

                  <b-col md="12">
                    <h3>Order</h3>
                  </b-col>
                  <b-col
                    md="12"
                    v-for="(line_order, index) in lines_order"
                    v-bind:key="index"
                    class="row"
                  >
                    <b-col md="12" class="row">
                      <b-col md="6">
                        <b-form-group label="Column" label-for="column_order">
                          <v-select
                            size="lg"
                            v-model="line_order.column_order"
                            :options="orderSelectOptions"
                            placeholder="Choose one or more..."
                          ></v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group label="Order" label-for="order">
                          <v-select
                            size="lg"
                            v-model="line_order.order"
                            :options="orderListOptions"
                            placeholder="Choose one or more..."
                          ></v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <label id="order" class="d-block"> Remove</label>
                        <button
                          type="button"
                          @click="removeLine(index, 'order')"
                          class="btn btn-block btn-outline-danger"
                          round
                        >
                          <i class="fa fa-trash"></i> Remove
                        </button>
                      </b-col>
                    </b-col>
                    <b-col>
                      <b-button
                        variant="primary"
                        v-if="index + 1 === lines_order.length"
                        @click="addLineOrder"
                        round
                      >
                        <i class="fa fa-plus"></i> Add Order
                      </b-button>
                    </b-col>
                  </b-col>

                  <hr class="mnr-md mnl-md" />

                  <b-col md="12">
                    <h3>Filters</h3>
                  </b-col>
                  <b-col
                    md="12"
                    v-for="(line_filter, index) in lines_filter"
                    v-bind:key="index + 99"
                    class="row"
                  >
                    <b-col md="12" class="row">
                      <b-col md="3">
                        <b-form-group label="Column" label-for="column_filter">
                          <v-select
                            size="lg"
                            v-model="line_filter.column_filter"
                            :options="orderSelectOptions"
                            placeholder="Choose one or more..."
                          ></v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group label="condition" label-for="condition">
                          <v-select
                            size="lg"
                            v-model="line_filter.condition"
                            :options="conditionListOptions"
                            placeholder="Choose one or more..."
                          ></v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group label="Value" label-for="value">
                          <b-form-input
                            id="value"
                            type="text"
                            v-model="line_filter.value"
                            autofocus
                          />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2
                            characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col md="1">
                        <label id="dynamic" class="d-block">Dynamic?</label>
                        <b-form-group label-class="font-weight-bold pt-0">
                          <c-switch
                            class="mx-1"
                            variant="3d"
                            dataOn=""
                            dataOff=""
                            color="success"
                            :checked="line_filter.dynamic"
                            label
                            v-model.lazy="line_filter.dynamic"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <label id="order" class="d-block"> Remove</label>
                        <button
                          type="button"
                          @click="removeLine(index, 'filter')"
                          class="btn btn-block btn-outline-danger"
                          round
                        >
                          <i class="fa fa-trash"></i> Remove
                        </button>
                      </b-col>
                    </b-col>
                    <b-col>
                      <b-button
                        variant="primary"
                        v-if="index + 1 === lines_filter.length"
                        @click="addLineFilter"
                        round
                      >
                        <i class="fa fa-plus"></i> Add Filter
                      </b-button>
                    </b-col>
                  </b-col>
                </b-tab>

                <!-- ### Data TAB ### -->
                <b-tab
                  v-if="isgraph"
                  v-on:click="assignCurrentTab('2')"
                  title="Graphs"
                >
                  <b-row>
                    <b-col md="12">
                      <h3>Graphs/tables to include in the report</h3>
                    </b-col>
                    <b-col md="6">
                      <div class="list-box-wrapper">
                        <div class="subject-info-box-1">
                          <b-form-group>
                            <b-form-select
                              ref="lstBoxGraphLeft"
                              class="form-control"
                              :plain="true"
                              :multiple="true"
                              :options="graphOptionsLeft"
                              v-model="box_graph1"
                            >
                            </b-form-select>
                          </b-form-group>
                        </div>

                        <div class="subject-info-arrows text-center">
                          <input
                            type="button"
                            id="btnAllRight"
                            v-on:click="btnGraphAllRight('>>')"
                            value=">>"
                            class="btn btn-default"
                          /><br />
                          <input
                            type="button"
                            id="btnRight"
                            v-on:click="btnGraphRight('>')"
                            value=">"
                            class="btn btn-default"
                          /><br />
                          <input
                            type="button"
                            id="btnLeft"
                            v-on:click="btnGraphLeft('<')"
                            value="<"
                            class="btn btn-default"
                          /><br />
                          <input
                            type="button"
                            id="btnAllLeft"
                            v-on:click="btnGraphAllLeft('<<')"
                            value="<<"
                            class="btn btn-default"
                          />
                        </div>

                        <div class="subject-info-box-2">
                          <b-form-group>
                            <b-form-select
                              ref="lstBoxGraphRight"
                              class="form-control"
                              :plain="true"
                              :multiple="true"
                              :options="graphOptionsRight"
                              v-model="box_graph2"
                            >
                            </b-form-select>
                          </b-form-group>
                        </div>

                        <div class="clearfix"></div>
                      </div>
                    </b-col>
                    <b-col md="6"> </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </div>
          </b-col>

          <b-col md="2" class="">
            <b-card>
              <!-- Published -->
              <label id="published" class="d-block">
                Published
              </label>
              <c-switch
                class="mx-1"
                variant="3d"
                dataOn=""
                dataOff=""
                color="success"
                :checked="published"
                label
                v-model.lazy.trim="published"
              />
              <!-- System Report -->
              <label id="systemReport" class="d-block">
                System Report
                <i
                  v-b-popover.hover.top="
                    'Enable to match scans with any verify code'
                  "
                  title="Info"
                  class="fa fa-question-circle"
                ></i>
              </label>
              <c-switch
                class="mx-1"
                variant="3d"
                dataOn=""
                dataOff=""
                color="success"
                :checked="systemReport"
                label
                v-model.lazy.trim="systemReport"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Modal Component -->
    <div>
      <Modals ref="form"></Modals>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  sameAs,
  helpers
} from "vuelidate/lib/validators";
import { Switch as cSwitch } from "@coreui/vue";
import { router } from "../../router/index";
import { mapState, mapActions } from "vuex";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { apigClient } from "@/shared/api";
import { cipher } from "@/shared/cipher";
import { userPool } from "@/shared/cognito";
import ActivityLog from "@/containers/ActivityLog";
import { ClientTable, Event } from "vue-tables-2";
import Modals from "@/shared/Modals.vue";
import { timezones } from "@/shared/helper";
import vSelect from "vue-select";
import { VueEditor } from "vue2-editor";
const Spinner = () => import("../shared/Spinner");
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);
Vue.use(ClientTable);
const strongPass = helpers.regex(
  "strongPass",
  /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
);
const formShape = {
  dataSource_name: null,
  analyticReportName: "",
  description: "",
  published: null,
  systemReport: null
};
let validations = {
  form: {
    dataSource_name: {
      required: true,
      minLength: minLength(2)
    },
    analyticReportName: {
      required: true
    },
    description: {
      required: true
    },
    published: {
      required: true
    },
    systemReport: {
      required: true
    }
  }
};
export default {
  name: "Analytics",
  components: {
    cSwitch,
    Spinner,
    vSelect,
    VueEditor,
    Modals
  },
  data() {
    if (window.location.href.includes("/analytics/edit")) {
      var analytic_id = localStorage.getItem("page_analytic_id");
      var analytic_name = localStorage.getItem("page_analytic_name");
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem("loginUserInfo")),
      form: Object.assign({}, formShape),
      feedBack: "secondary",
      submitted: false,
      disabled: true,
      isLoading: true,
      isgraph: false,
      isdata: false,
      isSelect: null,
      selectedForm: "basicInfo",
      modalMergeOpen: false,
      analytic_id: analytic_id || null,
      analytic_name: analytic_name || null,
      published: null,
      systemReport: null,
      dataSource: [],
      description: null,
      //line
      lines_order: [],
      lines_filter: [],
      dataOrder: [],
      dataFilter: [],
      blockRemoval_order: true,
      blockRemoval_filter: true,
      //areaOrder
      orderListOptions: [
        { value: "asc", label: "Ascending" },
        { value: "desc", label: "Descending" }
      ],
      //areaFilter
      value: [],
      blockRemoval: true,
      conditionListOptions: [
        { value: "=", label: "equals" },
        { value: ">", label: "greater than" },
        { value: ">=", label: "greather than or equal" },
        { value: "<", label: "less than" },
        { value: "<=", label: "less than or equal" },
        { value: "!=", label: "not equal" },
        { value: "notLike", label: "not like" }
      ],
      orderSelectOptions: [],
      filterSelectOptions: [],
      columnOptionsLeft: [],
      columnOptionsRight: [],
      graphOptionsLeft: [],
      graphOptionsRight: [],
      box_column1: [],
      box_column2: [],
      box_graph1: [],
      box_graph2: [],
      dataSource_dataColumns: [],
      dataSource_graphTables: []
    };
  },
  watch: {
    lines_order() {
      this.blockRemoval_order = this.lines_order.length <= 1;
    },
    lines_filter() {
      this.blockRemoval_filter = this.lines_filter.length <= 1;
    }
  },
  mounted: function() {
    if (this.analytic_id) {
      this.loadData();
    } else {
      this.addLineOrder();
      this.addLineFilter();
    }
    this.getDataSources();

    this.addGraph();
  },
  computed: {
    formStr() {
      return JSON.stringify(this.form, null, 4);
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
    isDirty() {
      return this.$v.form.$anyDirty;
    }
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
    handleChangeDataSource: function() {
      this.graphOptionsLeft = [];
      this.graphOptionsRight = [];
      this.columnOptionsRight = [];

      let dataSource_name = this.$v.form["dataSource_name"];
      this.isdata = true;
      this.getDataAnalytics(dataSource_name.$model.label);
      let that = this;
      if (dataSource_name.$model.graphTables != null) {
        that.isgraph = true;
        // set time out for wait element graph
        setTimeout(() => {
          let data = dataSource_name.$model.graphTables;
          for (var i = 0; i < data.length; i++) {
            var graphListJSON = {
              value: data[i]["value"],
              text: data[i]["name"]
            };
            that.graphOptionsLeft.push(graphListJSON);
          }
        }, 1000);
      } else {
        that.isgraph = false;
      }
    },
    getDataAnalytics(dataSource_name) {
      this.columnOptionsLeft = [];
      this.columnOptionsRight = [];
      this.orderSelectOptions = [];
      var method = "POST";
      var pathTemplate = "/analytics-columns";
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      var body = {
        datasource: dataSource_name
      };
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(results) {
          var data = results["data"]["data"];
          for (var i = 0; i < data.length; i++) {
            var columnListJSON = {
              value: data[i],
              text: data[i],
              label: data[i]
            };
            that.columnOptionsLeft.push(columnListJSON);
            that.orderSelectOptions.push(columnListJSON);
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    },
    routerBack() {
      this.$router.go(-1);
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true;
          this.feedBack = "info";
        });
      }
    },
    chkState(val) {
      const field = this.$v.form[val];
      let analyticReportName = this.$v.form["analyticReportName"];
      let basicFieldsInvalid =
        analyticReportName.$model !== undefined &&
        analyticReportName.$model !== "";
      this.disabled = !basicFieldsInvalid;
      return field.$model !== "" && field.$model !== undefined
        ? !field.$dirty || !field.$invalid
        : null;
    },
    loadData: function() {
      var method = "GET";
      var pathTemplate = "/analyticReports/" + this.analytic_id;
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          if (results.data.status) {
            var data = results["data"]["data"];
            that.form.analyticReportName = data.analyticReportName;
            that.form.dataSource_name = data.dataSource_name;
            that.description = data.description;
            that.lines_order = data.dataOrder;
            that.lines_filter = data.dataFilter;
            that.published = data.published;
            that.systemReport = data.systemReport;
            that.loadColumn(data.dataSource_dataColumns);
            that.loadGraph(data.dataSource_graphTables);
            data.dataOrder.length == 0 ? that.addLineOrder() : null;
            data.dataFilter.length == 0 ? that.addLineFilter() : null;
          } else {
            that.showErrorMsg({ message: results.data.message });
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    },
    getDataSources() {
      var method = "GET";
      var pathTemplate = "/dataSources";
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          var data = results["data"]["data"];
          for (var i = 0; i < data.length; i++) {
            var columnListJSON = {
              value: data[i]["id"],
              label: data[i]["dataSourceName"],
              graphTables: data[i]["graphTables"]
            };
            that.dataSource.push(columnListJSON);
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    },
    assignCurrentTab(value) {
      this.currentTab = value;
    },
    addLineOrder() {
      let checkEmptyLines_order = this.lines_order.filter(
        line_order => line_order.number === null
      );
      checkEmptyLines_order++;
      if (checkEmptyLines_order.length >= 1 && this.lines_order.length > 0)
        return;
      this.lines_order.push({
        order: null,
        column_order: null
      });
    },
    addLineFilter() {
      let checkEmptyLines_filter = this.lines_filter.filter(
        line_filter => line_filter.number === null
      );
      checkEmptyLines_filter++;
      if (checkEmptyLines_filter.length >= 1 && this.lines_filter.length > 0)
        return;
      this.lines_filter.push({
        column_filter: null,
        value: null,
        condition: null
      });
    },
    removeLine(lineId, area) {
      if (area == "order") {
        if (!this.blockRemoval_order) this.lines_order.splice(lineId, 1);
      } else {
        if (!this.blockRemoval_filter) this.lines_filter.splice(lineId, 1);
      }
    },
    post: function(option) {
      let that = this;
      let nodata = null;
      this.lines_order.forEach(lines => {
        if (lines.column_order) {
          let field = {
            column_order: lines.column_order,
            order: lines.order
          };
          this.dataOrder.push(field);
        }
      });
      this.lines_filter.forEach(lines => {
        if (lines.column_filter) {
          let field = {
            column_filter: lines.column_filter,
            value: lines.value,
            condition: lines.condition,
            dynamic: lines.dynamic
          };
          this.dataFilter.push(field);
        }
      });
      let body = {
        analyticReportName: that.form.analyticReportName || nodata,
        dataSource_name: that.form.dataSource_name || nodata,
        description: that.description || nodata,
        dataOrder: that.dataOrder || nodata,
        dataFilter: that.dataFilter || nodata,
        dataSource_dataColumns: that.columnOptionsRight || nodata,
        dataSource_graphTables: that.graphOptionsRight || nodata,
        published: that.published || nodata,
        systemReport: that.systemReport || nodata
      };
      if (false) {
      } else {
        if (this.analytic_id) {
          // Do PUT to API insert into Database
          this.$refs.form.openModal();
          that.changeModalContent(
            "loading",
            "Updating...",
            "Updating Analytics Info"
          );
          var method = "PUT";
          var pathTemplate = "/analyticReports/" + this.analytic_id;
          var additionalParams = {};
          var pathParams = {};
          apigClient
            .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(function() {
              console.log(
                "update a analytic, analytic_id: " + that.analytic_id
              );
              that.changeModalContent(
                "success",
                "Updated success!",
                "The Analytics data has been created"
              );
              if (option == "andClose") {
                setTimeout(() => {
                  that.routerBack();
                }, 1000);
              } else {
                setTimeout(() => {
                  that.openViewPage();
                }, 1000);
              }
            })
            .catch(function(result) {
              // that.showErrorMsg();
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            });
        } else {
          this.$refs.form.openModal();
          var method = "POST";
          var pathTemplate = "/analyticReports";
          var additionalParams = {};
          var pathParams = {};
          apigClient
            .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(function(result) {
              console.log(
                "create a new analytic, analytic_id: " + result["data"]["data"]
              );
              if (option == "andClose") {
                localStorage.setItem(
                  "page_analytic_id",
                  result["data"]["data"]
                );
                that.changeModalContent(
                  "success",
                  "Updated success!",
                  "The Analytics data has been created"
                );
                setTimeout(() => {
                  that.routerBack();
                }, 1000);
              } else {
                that.changeModalContent(
                  "success",
                  "Updated success!",
                  "The Analytics data has been created"
                );
                setTimeout(() => {
                  that.$refs.form.closeModal();
                }, 1000);
              }
            })
            .catch(function(result) {
              console.log(result);
              // that.showErrorMsg();
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result
              );
            });
        }
        this.isLoading = false;
      }
    },
    //columnlist
    loadColumn(arr) {
      setTimeout(() => {
        for (let i = 0; i < arr.length; i++) {
          let option = { value: arr[i].value, text: arr[i].text };
          this.columnOptionsRight.push(option);
          setTimeout(() => {
            var removeIndex = this.columnOptionsLeft
              .map(function(item) {
                return item.value;
              })
              .indexOf(arr[i].value);
            this.columnOptionsLeft.splice(removeIndex, 1);
          }, 1000);
        }
      }, 1500);
    },
    btnColumnRight() {
      var selectedOpts = this.$refs.lstBoxColumnLeft.value;
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        return;
      }
      let text = { value: selectedOpts[0], text: selectedOpts[0] };
      this.columnOptionsRight.push(text);
      var removeIndex = this.columnOptionsLeft
        .map(function(item) {
          return item.value;
        })
        .indexOf(selectedOpts[0]);
      this.columnOptionsLeft.splice(removeIndex, 1);
    },
    btnColumnAllRight() {
      var selectedOpts = this.$refs.lstBoxColumnLeft;
      for (let i = 0; i < selectedOpts.options.length; i++) {
        let text = {
          value: selectedOpts.options[i].value,
          text: selectedOpts.options[i].value
        };
        this.columnOptionsRight.push(text);
        this.columnOptionsLeft = [];
      }
    },
    btnColumnLeft() {
      var selectedOpts = this.$refs.lstBoxColumnRight.value;
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        return;
      }
      let text = { value: selectedOpts[0], text: selectedOpts[0] };
      this.columnOptionsLeft.push(text);
      var removeIndex = this.columnOptionsRight
        .map(function(item) {
          return item.value;
        })
        .indexOf(selectedOpts[0]);
      this.columnOptionsRight.splice(removeIndex, 1);
    },
    btnColumnAllLeft() {
      var selectedOpts = this.$refs.lstBoxColumnRight;
      for (let i = 0; i < selectedOpts.options.length; i++) {
        let text = {
          value: selectedOpts.options[i].value,
          text: selectedOpts.options[i].value
        };
        this.columnOptionsLeft.push(text);
        this.columnOptionsRight = [];
      }
    },
    openViewPage: function() {
      localStorage.setItem("page_analytic_id", this.analytic_id);
      localStorage.setItem("page_analytic_name", this.analytic_name);
      router.push("/analytics/view");
    },
    //graph list
    loadGraph(arr) {
      setTimeout(() => {
        for (let i = 0; i < arr.length; i++) {
          let option = { value: arr[i].value, text: arr[i].text };
          this.graphOptionsRight.push(option);
          setTimeout(() => {
            var removeIndex = this.graphOptionsLeft
              .map(function(item) {
                return item.value;
              })
              .indexOf(arr[i].value);
            this.graphOptionsLeft.splice(removeIndex, 1);
          }, 1000);
        }
      }, 1500);
    },
    addGraph() {
      var method = "GET";
      var pathTemplate = "/graphs";
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          var data = results["data"]["data"];
          for (var i = 0; i < data.length; i++) {
            var columnListJSON = {
              value: data[i]["graphType"].value,
              text: data[i]["graphName"]
            };
            that.graphOptionsLeft.push(columnListJSON);
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    },
    btnGraphRight() {
      var selectedOpts = this.$refs.lstBoxGraphLeft.value;
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        return;
      }
      let text = { value: selectedOpts[0], text: selectedOpts[0] };
      this.graphOptionsRight.push(text);
      var removeIndex = this.graphOptionsLeft
        .map(function(item) {
          return item.value;
        })
        .indexOf(selectedOpts[0]);
      this.graphOptionsLeft.splice(removeIndex, 1);
    },
    btnGraphAllRight() {
      var selectedOpts = this.$refs.lstBoxGraphLeft;
      for (let i = 0; i < selectedOpts.options.length; i++) {
        let text = {
          value: selectedOpts.options[i].value,
          text: selectedOpts.options[i].value
        };
        this.graphOptionsRight.push(text);
        this.graphOptionsLeft = [];
      }
    },
    btnGraphLeft() {
      var selectedOpts = this.$refs.lstBoxGraphRight.value;
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        return;
      }
      let text = { value: selectedOpts[0], text: selectedOpts[0] };
      this.graphOptionsLeft.push(text);
      var removeIndex = this.graphOptionsRight
        .map(function(item) {
          return item.value;
        })
        .indexOf(selectedOpts[0]);
      this.graphOptionsRight.splice(removeIndex, 1);
    },
    btnGraphAllLeft() {
      var selectedOpts = this.$refs.lstBoxGraphRight;
      for (let i = 0; i < selectedOpts.options.length; i++) {
        let text = {
          value: selectedOpts.options[i].value,
          text: selectedOpts.options[i].value
        };
        this.graphOptionsLeft.push(text);
        this.graphOptionsRight = [];
      }
    },
    // set modal
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    }
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The Analytic data has been create"
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The Analytic data has been update"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Warning",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: null,
      message: ""
    }
  }
};
</script>

<style scoped>
.btn.disabled {
  cursor: auto;
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  border: 1px solid #a4acb5;
}
@media only screen and (max-width: 600px) {
  .custom-header {
    flex-direction: column;
    align-items: inherit;
  }
  .custom-header > div:first-child {
    margin-bottom: 10px;
  }
}
.custom-cancel {
  border-radius: 0.25rem 0 0 0.25rem;
}
.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}
label {
  font-weight: 600 !important;
}

#language {
  margin-top: 15px;
}
.custom-header {
  display: flex;
  justify-content: space-between;
}
select {
  /* for Firefox */
  -moz-appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
}
/* For IE10 */
select::-ms-expand {
  display: none;
}
.tech-image {
  height: 15px;
}
.form-group label.required:after {
  content: " *";
  color: #f86b4f;
}
.color-20a8d8 {
  color: #20a8d8;
}
.underline {
  text-decoration: underline;
}
.font-size-13 {
  font-size: 13px !important;
}
.color-red {
  color: red;
}
.margin-bottom-5 {
  margin-bottom: 5px;
}
.subject-info-box-1,
.subject-info-box-2 {
  float: left;
  width: 45%;
}
select {
  height: 15em !important;
  padding: 0;
}
select option:hover {
  background: #eeeeee;
}
.subject-info-arrows {
  float: left;
  width: 10%;
}
input {
  width: 70%;
  margin-bottom: 5px;
}
.btn-default {
  border: 1px solid #c8ced3;
  border-radius: 0.25rem;
  width: 40px;
}
.btn-default:hover {
  border: 1px solid #80c1d0;
  border-radius: 0.25rem;
  width: 40px;
}
</style>
